import React, { useEffect, useState, Fragment } from 'react'
import ScriptLoader from './../../ScriptLoader'
import { numberFormatterWithOptional2Dp } from './../../../Utils/Formatters'
import { copyStringToClipboard } from './../../../Utils/Elements/index.js'
import { GridItem } from './../../../Components/Page/StatsPageWrapper'

// So that we can hook into this method for the tooltip 'Copy' button
window['scatterChart_copyStringToClipboard'] = copyStringToClipboard

/**
 * A scatter chart. Renders via the Google Charts.
 * @param {Array<string>} props.axisKeys The x and y axis keys of the data to
 * use for the scatter chart display.
 * e.g. `['metric-156-cvr', 'metric-156-cps']`
 * @param {Array<StatsLegend>} props.data.legend The different props to display
 * data for.
 * @param {Array<object>} props.data.data An array of objects. The key will
 * match the legends key and the value will be the value.
 * @param {string} props.titleKey The data value to show as the title in the
 * tooltips.
 * @param {string} props.title The title of the chart
 */
const GScatterChart = props => {
  // Setup a unique id we can use to render the Google stuff inside
  var [containerId] = useState('scatter-chart-' + new Date())

  useEffect(() => {
    google.charts.load('current', { 'packages': ['corechart'] })
    google.charts.setOnLoadCallback(function drawChart() {
      // Map our data to the Google data format
      var legend = props.axisKeys.map(
        key => props.data.legend.find(l => l.key == key).label,
      )
      var data = props.data.data.map(d => props.axisKeys.map(key => d[key]))
      var dataTableRawData = {
        cols: legend.map(label => ({ type: 'number', label })),
        rows: data.map(row => {
          return {
            c: row.map((v, i) => {
              return { v, f: `${v} ${legend[i]}` }
            }),
          }
        }),
      }

      // Add the custom tooltip configuration
      dataTableRawData.cols.push({
        type: 'string',
        role: 'tooltip',
        'p': { 'html': true },
      })
      dataTableRawData.rows.forEach((row, i) => {
        row.c.push({
          v: 'tooltip',
          f: buildToolTipHTML(
            props.titleKey,
            props.data.legend,
            props.data.data[i],
          ),
        })
      })

      // Create the data table
      var dataTable = new google.visualization.DataTable(dataTableRawData)
      var options = {
        //title: props.title,
        height: 400,
        hAxis: {
          title: props.data.legend.find(l => l.key == props.axisKeys[0]).label,
          minValue: 0,
          maxValue: Math.max(...data.map(d => d[0])),
          format: props.data.legend.find(l => l.key == props.axisKeys[0]).type,
        },
        vAxis: {
          title: props.data.legend.find(l => l.key == props.axisKeys[1]).label,
          minValue: 0,
          maxValue: Math.max(...data.map(d => d[1])),
          format: props.data.legend.find(l => l.key == props.axisKeys[1]).type,
        },
        legend: 'none',
        tooltip: {
          isHtml: true,
          trigger: 'selection',
        },
        explorer: { actions: ['dragToZoom', 'rightClickToReset'] },
      }
      var chart = new google.visualization.ScatterChart(
        document.getElementById(containerId),
      )

      chart.draw(dataTable, options)
    })
  }, [props.data, props.title, props.axisKeys, props.titleKey])
  return <div id={containerId} style={{ overflow: 'hidden' }} />
}

export default ({ title, ...otherProps }) => (
  <Fragment>
    <h1>{title}</h1>
    <GridItem>
      <ScriptLoader src="https://www.gstatic.com/charts/loader.js">
        <GScatterChart {...otherProps} />
      </ScriptLoader>
    </GridItem>
  </Fragment>
)

function buildToolTipHTML(titleKey, legend, data) {
  var locationName = data[titleKey]
  return `<div style="padding: 20px;">
    ${
      locationName
        ? `<h3 style="padding-left: 10px; padding-right: 10px;">${locationName}</h3>
    <button 
      style="float: right; color: white; border: none; padding: 4px 14px; font-size: 12px; margin-right: 30px; vertical-align: baseline; background-color: #f0405d;"
      onclick="window['scatterChart_copyStringToClipboard']('${locationName.replace(
        /'/g,
        "\\'",
      )}');"
    >Copy</button>`
        : ''
    }
    <table>
      ${legend
        .filter(l => l.key != titleKey)
        .map(legend => {
          var html = `<tr>
          <td style="padding-left: 10px; padding-right: 10px;">${
            legend.label
          }</td>
          <td style="padding-left: 10px; padding-right: 10px;">${(() => {
            var value = data[legend.key]
            switch (legend.type) {
              case 'currency':
                return numberFormatterWithOptional2Dp(value)
              case 'percent':
                return numberFormatterWithOptional2Dp(value * 100) + '%'
              default:
                return value
            }
          })()}</td>
        </tr>`

          return html
        })
        .join('')}
    </table>
  </div>`
}



// WEBPACK FOOTER //
// ./src/Components/Stats/GScatterChart/index.js